export default __webpack_public_path__ + "locales/ko-KR/SocialAuthWelcomeDialog.json?hash=eebff6d516860871dadc4c1cbdc1bbc3";